import React, { useState, useRef , Fragment} from "react";
import Config from "../../Config";

import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import InputText from "../../helpers/InputText";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";


function CalculateMove(props)
{ 
     
    const [row, setRow] = useState({
   
        det: props.row,

        p_saldo_ma_wn_id: props.row.id,
        max: props.row.pozostalo,

        p_subkonta_id: '_x_',
        p_subkonta_id_valid: false,

  
        tytul: '',
        tytul_valid: false,

        //laczna kwota do walidacji
        kwota: '',
        kwota_valid: false,
       
    });



    const [errTab, setErrTab] = useState([]);  //z info od serwera..


 

    const onBack = (e) => {
        props.goBack();
    }


    const goNextNew = () => {

    }


   
 
    const valChangeListener = (filedName, val, correct, msg) => { 
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);      


        if( (filedName == 'kwota'|| filedName == 'tytul' ) && row.p_subkonta_id != '_x_'   )
        {
           // setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct, ["p_subkonta_id"]:"_x_",  ["pozycje"]:null   } );
           // return;      
        }


        if(filedName == 'p_subkonta_id' || filedName == 'typ_wplaty' )
        {
           // setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct,   ["pozycje"]:null   } );   //pozycje na null by pobrało ponownie
        
           // return;
        }
 
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );                 
    }


    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const saveData = (e) => {

        
 
        if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }


            

        if(row.kwota.length < 1) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj kwotę' ,  "ok"  ,null); 
                return; 
            }

        if(row.kwota > row.max) 
           {
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Zbyt duża kwota, max: ' + row.max + " zł " ,  "ok"  ,null); 
                    return; 
          }

        

          if(row.det.subkonto.id == row.p_subkonta_id) 
            {
                     props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Wybierz inne subkonto niż źródłowe' ,  "ok"  ,null); 
                     return; 
           }


           
        props.mainView.setProgress(-2);


        var req = {
            id: row.p_saldo_ma_wn_id,
            kwota: row.kwota,
            p_subkonta_id: row.p_subkonta_id,
            rodzic_px_group_id: row.det.rodzic.id,
        };

        

    
        fetch( Config.url + '/rest_v1_calc,calc_split', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {

                            if(res.result == "1")
                            {
                                    props.mainView.showDialog('Sukces' , 'Kwota została przeniesiona. ' + row.max + " zł " ,  "ok"  , (p) => {
                                    props.onSuccess();
                                    } );
                            }

                            if(res.result == "0")
                            {
                                    props.mainView.showDialog('Sukces' , 'Nie można przenieść kwoty, która jest częściowo lub w całości rozliczona. '  ,  "ok"  , (p) => {
                                    props.onSuccess();
                                    } );
                            }
                            

                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }


  

 
    
    return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                    <br/>&nbsp;<br/>

                    <h1>Przenieś środki na inne subkonto</h1>

                    <p className="tip">
                        Uwaga: jeżeli przenosisz środki związane z przelewem bankowym to system podzieli przelew na dwa oddzielne przelewy. Drugi z nich zostanie umieszczony na wskazanym subkoncie. 
                    </p>


                    <div>
                    {row.det.subkonto.nazwa + " " + row.det.subkonto.numer_konta}
                    </div>

                    <div className="form_split"></div>

                    <div>
                     Rodzic: {row.det.rodzic.nazwisko + " " + row.det.rodzic.imie}
                    </div>

                    <div className="form_split"></div>

                    <div>
                     Dziecko: {row.det.dziecko.nazwisko + " " + row.det.dziecko.imie}
                    </div>

                    <div className="form_split"></div>
                    <br/>
                    <div className="form_split"></div>

                    <form className="eForm bg_center">

                                <div className="form_control">
                                        <div className="fieldName">Kwota operacji <b>(max.  <FormatDecimal value={row.max} /> ) </b> </div>
                                        <InputDecimal   userData={props.userData} value={ row.kwota} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={  "kwota" } placeholder={"Kwota:"} className='w100' req='0'   />                                                                                                         
                                </div>

                                <div className="form_split"></div>

                                <div className="form_control">      
                                        <div className="fieldName">Tytuł</div>
                                        <InputText   userData={props.userData} value={row.tytul} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Tytuł: np. Wpłata za wrzesień, zwrot, ..."} className='w300' req='1'   />
                                 </div>

                                 <div className="form_split"></div>

                                 {
                                      row.kwota != 0 && row.tytul.length > 2 &&
                                       <React.Fragment>

                                                      <div className="form_control">
                                                                 <div className="fieldName">Konto</div>
                                                                <InputComboSubkonto  userData={props.userData} mainView={props.mainView}  value={row.p_subkonta_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={""} className='  ' req='1'   />                                    
                                                      </div>
                                       </React.Fragment>
                                 }




                            {
                                            row.kwota != 0 && row.tytul.length > 2 &&
                                            <React.Fragment>
                                                    <div className="form_split"></div>

                                                    <div className="form_btn">
                                                            <div className="btn" onClick={saveData}>Przenieś na wskazane subkonto</div>
                                                            &nbsp;
                                                            <div className="btn" onClick={onBack}>Anuluj</div>
                                                    </div>
                                            </React.Fragment>
                            }    
                        
                    </form>



            </div>

}


export default CalculateMove;

